import { AfterContentInit, AfterViewInit, Component, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { DocStereoTypeDto } from 'projects/shared/src/lib/models/DocStereoTypeDto';
import { DocumentDto, DocumentStatusDto } from 'projects/shared/src/lib/models/DocumentDto';
import { ProjectSessionRequest } from 'projects/shared/src/lib/models/SquirrelSession';
import { ValueConfAttributesDto } from 'projects/shared/src/lib/models/ValueConfAttribute';
import { ValueConfPageDto, ValueConfPagesDto } from 'projects/shared/src/lib/models/ValueConfPage';
import { AttributeValueService } from 'projects/shared/src/lib/services/attribute-value.service';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';
import { DocumentService } from 'projects/shared/src/lib/services/document.service';
import { ValueConfPageService } from 'projects/shared/src/lib/services/value-conf-page.service';

import * as documentActions from 'projects/shared/src/lib/ngrx-store/document/document-actions';
import * as attributeValueActions from 'projects/shared/src/lib/ngrx-store/attribute-value/attribute-value-actions';
import * as valueConfPageActions from 'projects/shared/src/lib/ngrx-store/value-conf-page/value-conf-page.actions';

import { getValueConfPages } from 'projects/shared/src/lib/ngrx-store/value-conf-page/value-conf-page.selector';
import { getAttributeValue } from 'projects/shared/src/lib/ngrx-store/attribute-value/attribute-value.selector';
import { getDocument } from 'projects/shared/src/lib/ngrx-store/document/document.selector';

@Component({
  selector: 'edit-document',
  templateUrl: './edit-document.component.html',
  styleUrls: ['./edit-document.component.scss'],
  //encapsulation: ViewEncapsulation.Emulated //https://angular.io/guide/view-encapsulation
})
export class EditDocumentComponent implements OnInit, AfterContentInit {

  @Input() cntData: any;
  @Input() documentDto: any;
  @Input() documentStatus: any;
  @Input() documentName: any;
  @Input() controlData: any;
  @Input() valueConfPageDtos!: ValueConfPageDto[];

  // documentName!: string;
  // documentStatus!: string;
  // controlData: any;
  // cntData: any;
  // documentDto!: DocumentDto;
  // valueConfPageDtos: ValueConfPageDto[] = [];

  model: any = {};

  pageId!: string;

  errorMessage!: string;

  totalRecords = 0;
  currentPage = 1;
  pageSize = 10

  documentId!: string;
  dbName!: string;

  status!: string;
  color!: string;

  fieldName: any;
  eventValue: any;

  valueConfPageDto!: ValueConfPageDto;
  valueConfPagesDto!: ValueConfPagesDto;
  documentStatusDto!: DocumentStatusDto;

  constructor(private render: Renderer2,
    private dataSharingService: DataSharingService,
    private attributeValueService: AttributeValueService,
    // private store: Store<{
    //   docstereotypes: DocStereoTypeDto[],
    //   projectsessionreq: ProjectSessionRequest,
    //   document: DocumentDto,
    //   currentattributevalue: { controlData: string; selectControl: string; },
    //   valueconfpages: ValueConfPagesDto
    // }>
  ) { }

  ngOnInit(): void {
    this.dbName = localStorage.getItem('dbname') as string;
  

    // this.store.select(getDocument).subscribe({
    //   next: (document: any) => {
    //     let doc = document.document;
    //     this.documentDto = doc;
    //     this.documentName = doc.name;
    //     this.dataSharingService.passDocumentState(doc);
    //   }
    // })

    // this.store.select(getAttributeValue).subscribe({
    //   next: (currentattributevalue: any) => {
    //     console.log('----------------currentattributevalue-----------------------')
    //     console.log(currentattributevalue.currentattributevalue)
    //     console.log('---------------------------------------')

    //     this.controlData = currentattributevalue.currentattributevalue.controlData;

    //     this.cntData = JSON.parse(currentattributevalue.currentattributevalue.controlData);
    //     console.log('----------------cntData-----------------------')
    //     console.log(this.cntData)
    //     console.log('---------------------------------------')

    //     this.documentStatus = currentattributevalue.currentattributevalue.selectControl;

    //     if (this.documentStatus === 'Closed') {
    //       this.render.addClass(document.getElementById('document-status'), 'color-purple') // closed
    //     }
    //     else if (this.documentStatus === 'Open') {
    //       this.render.addClass(document.getElementById('document-status'), 'color-violet') // Open
    //     }
    //     else if (this.documentStatus === 'InProgress') {
    //       this.render.addClass(document.getElementById('document-status'), 'color-blue') // InProgress
    //     }
    //   }
    // });

    // this.store.select(getValueConfPages).subscribe({
    //   next: (valueconfpages: any) => {
    //     this.valueConfPageDtos = valueconfpages.valueconfpages.valueConfPageDtos;
    //     console.log('---------------valueConfPageDtos------------------------')
    //     console.log(this.valueConfPageDtos)
    //     console.log('---------------------------------------')
    //   }
    // });

    // if (this.documentStatus === 'Closed') {
    //   this.render.addClass(document.getElementById('document-status'), 'color-purple') // closed
    // }
    // else if (this.documentStatus === 'Open') {
    //   this.render.addClass(document.getElementById('document-status'), 'color-violet') // Open
    // }
    // else if (this.documentStatus === 'InProgress') {
    //   this.render.addClass(document.getElementById('document-status'), 'color-blue') // InProgress
    // }
  }

  ngAfterContentInit(): void {

    // this.dataSharingService.documentState.subscribe({
    //   next:(document: any) => {
    //     console.log('.............document...ngAfterContentInit.................')
    //     console.log(document)
    //     console.log('.............document...ngAfterContentInit.................')
    //     let doc = document.document;
    //     this.documentDto = doc;
    //     this.documentName = doc.name;
    //   }

    // })

    this.dataSharingService.documentName.subscribe({
      next: (doc: string) => {
        this.documentName = doc;
      }
    });

    this.dataSharingService.documentStatus.subscribe({
      next: (status: any) => {
        this.documentStatus = status as string;
        this.status = this.documentStatus;

        if (this.documentStatus === 'Done') {
          this.render.setStyle(document.getElementById('document-status'), 'border', '2px solid #e91e63');
          this.render.setStyle(document.getElementById('document-status'), 'background', '#e91e63');
        }
        if (this.documentStatus === 'Open') {
          this.render.setStyle(document.getElementById('document-status'), 'border', '2px solid #9c27b0');
          this.render.setStyle(document.getElementById('document-status'), 'background', '#9c27b0');
        }
        if (this.documentStatus === 'InProgress') {
          this.render.setStyle(document.getElementById('document-status'), 'border', '2px solid #673ab7');
          this.render.setStyle(document.getElementById('document-status'), 'background', '#673ab7');
        }
      },
      //error
    });

    this.dataSharingService.documentColor.subscribe({
      next: (color: any) => {
        this.color = color;
      }
    });

    // this.dataSharingService.documentNameChanges$.subscribe({
    //   next: (name: any) => {
    //     this.documentName = name as string;
    //   }
    // });

    // this.dataSharingService.documentStatusChanges$.subscribe({
    //   next: (status: any) => {
    //     this.documentStatus = status as string;
    //     this.status = this.documentStatus;

    //     if (this.documentStatus === 'Done') {
    //       this.render.setStyle(document.getElementById('document-status'), 'border', '2px solid #e91e63');
    //       this.render.setStyle(document.getElementById('document-status'), 'background', '#e91e63');
    //     }
    //     if (this.documentStatus === 'Open') {
    //       this.render.setStyle(document.getElementById('document-status'), 'border', '2px solid #9c27b0');
    //       this.render.setStyle(document.getElementById('document-status'), 'background', '#9c27b0');
    //     }
    //     if (this.documentStatus === 'InProgress') {
    //       this.render.setStyle(document.getElementById('document-status'), 'border', '2px solid #673ab7');
    //       this.render.setStyle(document.getElementById('document-status'), 'background', '#673ab7');
    //     }
    //   },
    //   // error
    // });

    // this.dataSharingService.documentColorChanges$.subscribe({
    //   next: (color: any) => {
    //     this.color = color as string;
    //   },
    //   //error
    // })    
  }

  expand(link: { id: string | null; }): void {

    this.pageId = link.id as string;
    this.attributeValueService.loadCurrentAttributeValue('', this.documentDto.id, this.pageId, this.currentPage, this.pageSize, this.dbName).subscribe({
      next: (attrValueDto: { controlData: string; }) => {
        this.dataSharingService.changeTabIdState(link.id);

        this.model = JSON.parse(attrValueDto.controlData);

        console.log(this.model)

      },
      // error
    })

  }


  tabChanged(tabChangeEvent: any): void {
    console.log(tabChangeEvent);
    //this.dataSharingService.changeTabIdState(tabChangeEvent.id)
  }

  isObject(val: string): string | undefined {
    if (val == 'fileInfo') {
      return val;
    }
    else {
      return ''
    }
  }

  docStatusHandler($event:any) {
    console.log('#####################$event########################')
    console.log($event.project_type)
    console.log('#####################$event########################')
    this.documentStatus = $event
  }
}

